import { ChangeEvent, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Space,
  Button,
  Spin,
  Modal,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
import {
  CreatedType,
  RegistrationResponseDto,
  RegistrationStatus,
} from "../../models/Registration";
import { phoneRegex, validatePersonalId } from "../../core/Utility";
import {
  createRegistration,
  getRegistration,
  updateRegistration,
} from "../../services/RegistrationService";
import { RoleType } from "../../models/Role";
import { getAllEvents } from "../../services/EventService";
import Home from "../../assets/home.png";
import Profile from "../../assets/profile.png";
import AddNewAccommodation from "../../components/AddNewAccommodation/AddNewAccommodation";
import "./NewRegistrationPage.scss";
import dayjs from "dayjs";
import { EventDto, EventListDto } from "../../models/Event";
import { Notification, NotificationType } from "../../models/Notification";
import {
  AccommodationDto,
  AdditionalPersonDto,
} from "../../models/Accommodation";
import { activeUser } from "../../services/AuthServices";
import { getAllNotifications } from "../../services/NotificationService";
import { addThousandSeparator } from "../../core/Utility";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Toast } from "primereact/toast";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import useFetchOneEvent from "../../customHooks/FetchOneEvent/FetchOneEvent";

const NewRegistrationPage = () => {
  const navigate = useNavigate();
  let { id } = useParams<{ id: string }>();
  const { setBreadcrumb, setNotificationNumber } = useApplicationContext();
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [idEvent, setIdEvent] = useState<string | undefined>(undefined);
  const [oneEvent, setOneEvent] = useState<EventDto | undefined>();
  const Option = Select.Option;
  const [allEvents, setAllEvents] = useState<EventListDto[]>([]);
  const [getData, setGetData] = useState(false);
  const isAccommodationRequired: boolean = Form.useWatch(
    "isAccommodationRequired",
    form
  );

  const [data] = useFetchOneEvent(idEvent);
  const [totalPrice, setTotalPrice] = useState(0);
  const [getNewPriceData, setGetNewPriceData] = useState<boolean>(false);
  const registrationFee = oneEvent?.registrationFee ?? 0;
  const toast = useRef<any>(null);

  const [fieldsFormData, setFieldsFormData] = useState<any>({
    country: "Srbija",
  });
  const [status, setSTatus] = useState(undefined);
  const [textMessage, setTextMessage] = useState<any>(undefined);
  const [phoneError, setPhoneError] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [oneRegistration, setOneRegistration] = useState<any>();

  const Country = [
    { label: "Srbija", value: "Srbija" },
    { label: "Inostranstvo", value: "Inostranstvo" },
  ];

  const documentType = [
    { label: "Predavač", value: "Predavač" },
    { label: "Učesnik", value: "Učesnik" },
    { label: "Gost", value: "Gost" },
    { label: "VIP", value: "VIP" },
    { label: "Sponzorisan", value: "Sponzorisan" },
  ];

  const accommodationArray: any = Array.from(
    { length: 1 },
    (_, index) => index
  ).map((el: any) => {
    return;
  });

  useEffect(() => {
    setShowInfoModal(invoice);
  }, [invoice]);

  useEffect(() => {
    const values = form.getFieldValue("accommodations");
    if (values?.length === 0) {
      handleTotalPrice(0);
      setGetData(false);
    }
  }, [getNewPriceData]);

  useEffect(() => {
    if (isAccommodationRequired) {
      if (getData) {
        const FieldValues = form.getFieldsValue();
        const newData: any = FieldValues;
        if (newData.accommodations && newData.accommodations.length !== 0) {
          const personBearer = { ...newData };
          delete personBearer.accommodations;
          newData.accommodations[0].additionalPerson[0] = personBearer;
          if (!newData.accommodations[0].numberOfPersons) {
            newData.accommodations[0].numberOfPersons = 1;
          }
        } else {
          setGetData(false);
        }
        form.setFieldValue("accommodations", newData.accommodations);
        handleGetPriceData(true);
      } else {
        form.setFieldValue("accommodations", accommodationArray);
      }
    } else {
      if (oneRegistration && data && id !== undefined) {
        const dinner = oneRegistration?.dinner;
        const registrationFee = oneRegistration?.registrationFee;

        handleTotalPrice(
          ((dinner && data?.dinnerFee) || 0) +
            ((registrationFee && data?.registrationFee) || 0)
        );
      }
    }
  }, [isAccommodationRequired, getData, fieldsFormData, data]);

  useEffect(() => {
    setOneEvent(data);
  }, [data]);

  useEffect(() => {
    if (id) {
      setActiveSpinner(true);
      getRegistration(id)
        .then((response: RegistrationResponseDto) => {
          let newObject = { ...response.data.result };
          if (response.data.result?.invoice?.sentEmail) {
            setInvoice(false); ///response.data.result.invoice.sentEmail // - ODBLOKIRAJ UNOS PROFAKTURE
          } else {
            setInvoice(false);
          }
          setGetData(true);
          setIdEvent(newObject?.event?.id);
          setFieldsFormData({ country: newObject?.country });
          newObject.event = newObject?.event?.id;
          if (newObject?.accommodations) {
            newObject.accommodations = newObject?.accommodations?.map(
              (el: AccommodationDto) => {
                return {
                  ...el,
                  date: [dayjs(el.date[0]), dayjs(dayjs(el.date[1]))],
                };
              }
            );
          } else {
            handleSpinner(false);
          }

          setOneRegistration(newObject);
          form.setFieldsValue(newObject);
        })
        .catch((err: Error) => console.log(err));
    } else {
      form.resetFields();
      setInvoice(false);
      setGetData(false);
      setIdEvent(undefined);
      setOneEvent(undefined);
      setTotalPrice(0);
    }
  }, [id]);

  useEffect(() => {
    setBreadcrumb(["Kreiranje prijave", "Prijava fizičko lice"]);
    getAllEvents().then((eventResponse) => {
      let newEventOptions: { label: string; value: string; id: string }[] = [];
      eventResponse.data.result?.map((eventItem: EventDto) => {
        newEventOptions.push({
          label: eventItem.name,
          value: eventItem.name,
          id: eventItem.id,
        });
      });
      setAllEvents(newEventOptions);
    });
  }, []);

  useEffect(() => {
    if (!status) return;
    if (status !== 409) {
      setSTatus(undefined);
      return navigate("/registration-list", { replace: true });
    } else {
      toast?.current?.show({
        severity: "error",
        detail: `Već postoji uneti broj telefona ${textMessage}.`,
        life: 3000,
      });
      setSTatus(undefined);
    }
  }, [status]);

  useEffect(() => {
    if (!isAccommodationRequired || isAccommodationRequired === undefined) {
      return setTotalPrice(registrationFee);
    }
  }, [registrationFee, isAccommodationRequired]);

  const handleInfoModal = () => {
    setShowInfoModal(false);
  };

  const handleGetPriceData = (get: boolean) => {
    setGetNewPriceData(get);
  };

  const handleSpinner = (show: boolean) => {
    return setActiveSpinner(show);
  };

  const handleTotalPrice = (price: any) => {
    setTotalPrice(price);
  };

  // const handleDinnerCalculation = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (!isAccommodationRequired) {
  //     if (e.target.checked) {
  //       setTotalPrice(totalPrice + data?.dinnerFee);
  //     } else {
  //       setTotalPrice(totalPrice - data?.dinnerFee);
  //     }
  //   }
  // };

  // const handleRegistrationFeeCalculation = (
  //   e: ChangeEvent<HTMLInputElement>
  // ) => {
  //   if (!isAccommodationRequired) {
  //     if (e.target.checked) {
  //       setTotalPrice(totalPrice + data?.registrationFee);
  //     } else {
  //       setTotalPrice(totalPrice - data?.registrationFee);
  //     }
  //   }
  // };

  const handleFieldsChanges = (e: any, name: string) => {
    const delayDebounceFn = setTimeout(() => {
      setFieldsFormData({ ...fieldsFormData, [name]: e.target.value });
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  };

  const handleSelectionChanges = (e: any, name: string) => {
    setFieldsFormData({ ...fieldsFormData, [name]: e });
  };

  const handleGetData = (get: boolean) => {
    setGetData(get);
  };

  const handleCheckboxGroup = (
    e: ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    if (name === "noAccommodation") {
      form.setFieldValue("isAccommodationRequired", false);
      // form.setFieldValue("accommodations", []);
      setGetData(false);
      // setTotalPrice(0);
    } else {
      form.setFieldValue("noAccommodation", false);
      // form.setFieldValue("additionalPerson", []);
    }
  };

  const handleEvent = (e: string) => {
    let values = form.getFieldValue("accommodations");
    if (values) {
      values = values.map((item: AccommodationDto) => {
        return (item = {
          ...item,
          accommodationId: undefined,
          roomType: undefined,
          date: undefined,
          parkingPlaces: undefined,
          priceOfAccommodation: undefined,
          note: undefined,
        });
      });

      form.setFieldValue("accommodations", values);
    }
    setIdEvent(e);
  };

  const handleConfirmSaveForm = () => {
    const fieldValuesAccommodations = form.getFieldValue("accommodations");

    let accommodationAdditionalPersonLength = 0;

    if (isAccommodationRequired) {
      fieldValuesAccommodations?.map((el: any) => {
        if (el?.additionalPerson?.length > 0) {
          return (accommodationAdditionalPersonLength =
            accommodationAdditionalPersonLength + el.additionalPerson.length);
        }
      });
    } else {
      if (!id) {
        return handleSaveForm();
      } else {
        return handleEditForm();
      }
    }

    if (accommodationAdditionalPersonLength !== 0) {
      if (!id) {
        return handleSaveForm();
      } else {
        return handleEditForm();
      }
    } else {
      toast?.current?.show({
        severity: "error",
        detail: `Nije moguće kreirati prijavu bez učesnika!`,
        life: 3000,
      });
    }
  };

  const handleSaveForm = () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setActiveSpinner(true);
        const formFieldsContent = form.getFieldsValue();

        let eventXRoomType = {};

        let accommodationID = {};

        delete formFieldsContent["noAccommodation"];

        const singleEvent = allEvents.filter((el: EventListDto) => {
          if (el.id === formFieldsContent.event) {
            return { id: el.id, name: el.value };
          }
        });

        formFieldsContent.event = {
          id: singleEvent[0].id,
          name: singleEvent[0].value,
        };

        if (formFieldsContent?.accommodations) {
          const roomIdArray = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.roomId;
            }
          );

          const roomTypeIdData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.roomType;
            }
          );

          const numberOfDaysData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.numberOfDays;
            }
          );

          const priceOfAccommodationData =
            formFieldsContent?.accommodations?.map(
              (el1: AccommodationDto, i: number) => {
                return el1.priceOfAccommodation / Number(el1.numberOfPersons);
              }
            );

          const parkingPlaceData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.parkingPlaces;
            }
          );

          const dateArray = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.date;
            }
          );

          formFieldsContent.date = dateArray[0];
          formFieldsContent.roomId = roomIdArray[0];
          formFieldsContent.roomTypeId = roomTypeIdData[0];
          formFieldsContent.numberOfDays = numberOfDaysData[0];
          formFieldsContent.priceOfAccommodation = priceOfAccommodationData[0];
          formFieldsContent.parkingPlace = parkingPlaceData[0];
        }
        formFieldsContent.user = { id: activeUser?.id };

        formFieldsContent?.accommodations?.map(
          (el1: AccommodationDto, i: number) => {
            el1?.additionalPerson?.map((el: AdditionalPersonDto, j: number) => {
              eventXRoomType = { id: el1.roomType };
              accommodationID = { id: el1.accommodationId };
              let copyOfNewEl = {
                ...el,
                status: RegistrationStatus.Pending,
                lastStatusChange: new Date(),
                roomId: el1.roomId,
                eventXRoomType: { id: el1.roomType },
                accommodation: { id: el1.accommodationId },
                user: { id: activeUser?.id },
                uosPayment: el1.uosPayment,
                roomTypeId: el1.roomType,
                numberOfDays: el1.numberOfDays,
                priceOfAccommodation:
                  Number(el1.priceOfAccommodation) /
                  Number(el1.numberOfPersons),
                parkingPlace: el1.parkingPlaces,
                createdType: CreatedType.Administration,
                event: {
                  id: singleEvent[0].id,
                  name: singleEvent[0].value,
                },
              };
              formFieldsContent.accommodations[i].additionalPerson[j] =
                copyOfNewEl;
            });
          }
        );

        formFieldsContent.eventXRoomType = eventXRoomType;

        formFieldsContent.accommodation = accommodationID;

        formFieldsContent.totalPrice = totalPrice;

        formFieldsContent.createdType = CreatedType.Administration;

        const completeRegistration = {
          ...formFieldsContent,
          status: RegistrationStatus.Pending,
          isCompanyRegistration: false,
          lastStatusChange: new Date(),
        };

        createRegistration(completeRegistration)
          .then(() => {
            toast?.current?.show({
              severity: "success",
              detail: "Uspešno kreirana prijava",
              life: 3000,
            });
            let copyOfNewNotifications: Notification[] = [];
            getAllNotifications().then((response) => {
              setSTatus(response.status);
              setTextMessage("");
              response.data.result.map((item: any) => {
                if (
                  activeUser?.role.name === RoleType.Agency &&
                  item.type === NotificationType.AGENCY
                ) {
                  copyOfNewNotifications.push(item);
                }
                if (
                  activeUser?.role.name === RoleType.Employee &&
                  item.type === NotificationType.EMPLOYEE
                ) {
                  copyOfNewNotifications.push(item);
                }
                if (activeUser?.role.name === RoleType.Admin) {
                  copyOfNewNotifications.push(item);
                }
              });
              const unseenNotifications = copyOfNewNotifications.filter(
                (oneNotification: Notification) =>
                  oneNotification.seen === false
              );
              setNotificationNumber(unseenNotifications.length);
            });
          })
          .catch((err: any) => {
            setActiveSpinner(false);
            let text = err.response.data.message.match(/\d/g);
            text = text.join("");
            setTextMessage(text);
            setSTatus(err.response.status);
          });
      },
      () => {
        console.log("");
      }
    );
  };

  const handleEditForm = () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        let eventXRoomType = {};

        let accommodationID = {};

        setActiveSpinner(true);
        const formFieldsContent = form.getFieldsValue();

        delete formFieldsContent["noAccommodation"];

        const singleEvent = allEvents.filter((el: EventListDto) => {
          if (el.id === formFieldsContent.event) {
            return { id: el.id, name: el.value };
          }
        });

        formFieldsContent.event = {
          id: singleEvent[0].id,
          name: singleEvent[0].value,
        };

        if (formFieldsContent?.accommodations) {
          const roomIdArray = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.roomId;
            }
          );

          const roomTypeIdData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.roomType;
            }
          );

          const numberOfDaysData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.numberOfDays;
            }
          );

          const priceOfAccommodationData =
            formFieldsContent?.accommodations?.map(
              (el1: AccommodationDto, i: number) => {
                return el1.priceOfAccommodation;
              }
            );

          const parkingPlaceData = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.parkingPlaces;
            }
          );

          const dateArray = formFieldsContent?.accommodations?.map(
            (el1: AccommodationDto, i: number) => {
              return el1.date;
            }
          );

          formFieldsContent.date = dateArray[0];
          formFieldsContent.roomId = roomIdArray[0];
          formFieldsContent.roomTypeId = roomTypeIdData[0];
          formFieldsContent.numberOfDays = numberOfDaysData[0];
          formFieldsContent.priceOfAccommodation = priceOfAccommodationData[0];
          formFieldsContent.parkingPlace = parkingPlaceData[0];
        }
        formFieldsContent.user = { id: activeUser?.id };

        formFieldsContent?.accommodations?.map(
          (el1: AccommodationDto, i: number) => {
            el1.additionalPerson?.map((el: AdditionalPersonDto, j: number) => {
              eventXRoomType = { id: el1.roomType };
              accommodationID = { id: el1.accommodationId };
              let copyOfNewEl = {
                ...el,
                status: el.status ? el.status : RegistrationStatus.Pending,
                lastStatusChange: new Date(),
                roomId: el1.roomId,
                eventXRoomType: { id: el1.roomType },
                accommodation: { id: el1.accommodationId },
                user: { id: activeUser?.id },
                uosPayment: el1.uosPayment,
                roomTypeId: el1.roomType,
                numberOfDays: el1.numberOfDays,
                priceOfAccommodation:
                  Number(el1.priceOfAccommodation) /
                  Number(el1.numberOfPersons),
                parkingPlace: el1.parkingPlaces,
                createdType: CreatedType.Administration,
                event: {
                  id: singleEvent[0].id,
                  name: singleEvent[0].value,
                },
              };
              formFieldsContent.accommodations[i].additionalPerson[j] =
                copyOfNewEl;
            });
          }
        );

        formFieldsContent.user = { id: activeUser?.id };

        formFieldsContent.eventXRoomType = eventXRoomType;

        formFieldsContent.accommodation = accommodationID;

        formFieldsContent.totalPrice = totalPrice;

        formFieldsContent.createdType = CreatedType.Administration;

        const completeRegistration = {
          ...formFieldsContent,
          isCompanyRegistration: false,
          lastStatusChange: new Date(),
        };

        updateRegistration(id, completeRegistration)
          .then((response) => {
            setSTatus(response.status);
            setTextMessage("");
            toast?.current?.show({
              severity: "success",
              detail: "Uspešno ažurirani podaci o prijavi",
              life: 3000,
            });
          })
          .catch((err: any) => {
            setActiveSpinner(false);
            let text = err.response.data.message.match(/\d/g);
            text = text.join("");
            setTextMessage(text);
            setSTatus(err.response.status);
          });
      },
      () => {
        console.log("");
      }
    );
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <div
        className={
          !invoice
            ? "new-registration"
            : "new-registration disabled-registration"
        }
      >
        <Spin spinning={activeSpinner}>
          <Form
            form={form}
            name="new-legal-entity-form"
            layout="vertical"
            autoComplete="off"
          >
            <div className="header-box">
              <div className="wrapper">
                <img className="image" alt="" src={Home} />
                <p className="accordion-header" style={{ marginLeft: "10px" }}>
                  Lični podaci
                </p>
              </div>
            </div>
            <div className="inner-box">
              <Form.Item
                name={"event"}
                label="Prijava za događaj:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je da odaberete događaj!",
                  },
                ]}
              >
                <Select onChange={handleEvent} placeholder="Izaberite događaj">
                  {allEvents.map((el: EventListDto, i: number) => (
                    <Option key={el.id} value={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={"type"}
                label="Tip učesnika:"
                rules={[
                  {
                    required: true,
                    message: "Izaberite tip učesnika!",
                  },
                ]}
              >
                <Select
                  onChange={(e) => handleSelectionChanges(e, "type")}
                  placeholder="Tip učesnika"
                  options={documentType}
                />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"firstName"}
                label="Ime:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti ime!",
                  },
                ]}
              >
                <Input
                  onChange={(e) => handleFieldsChanges(e, "firstName")}
                  className="input-label"
                  placeholder="Unesite ime"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"lastName"}
                label="Prezime:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti prezime!",
                  },
                ]}
              >
                <Input
                  onChange={(e) => handleFieldsChanges(e, "lastName")}
                  className="input-label"
                  placeholder="Unesite prezime"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <div className="phone-input-container">
                <Form.Item
                  className="form-box"
                  name={"phone"}
                  label="Kontakt telefon:"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    {
                      validateTrigger: "onChange",
                      validator: async (_, value) => {
                        if (value === undefined || value === null) {
                          return setPhoneError(true);
                        } else {
                          if (!phoneRegex.test(value)) {
                            setPhoneError(true);
                            return Promise.reject();
                          } else {
                            setPhoneError(false);
                            return Promise.resolve();
                          }
                        }
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    placeholder="Unesite broj telefona"
                    onChange={(e) => handleSelectionChanges(e, "phone")}
                    className={phoneError ? "phone-input-error" : "phone-input"}
                  />
                </Form.Item>
                {
                  <p
                    className={
                      !phoneError
                        ? "phone-description"
                        : "phone-description-no-visible"
                    }
                  >
                    Unesite ispravan format +381 66 12345678
                  </p>
                }
              </div>
              <Form.Item
                className="form-box"
                name={"email"}
                label="E-mail:"
                rules={[
                  {
                    required: true,
                    message: "Potrebno je uneti e-mail adresu!",
                  },
                  {
                    type: "email",
                    message: "Unesite ispravan format e-maila!",
                    validateTrigger: "submit",
                  },
                ]}
              >
                <Input
                  onChange={(e) => handleFieldsChanges(e, "email")}
                  className="input-label"
                  placeholder="Unesite e-mail adresu"
                  addonAfter={<EditOutlined />}
                />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"country"}
                label="Zemlja:"
                rules={[
                  {
                    required: true,
                    message: "Izaberite Zemlju!",
                  },
                ]}
              >
                <Select
                  onChange={(e) => handleSelectionChanges(e, "country")}
                  placeholder="Izaberite Zemlju"
                  options={Country}
                />
              </Form.Item>

              {/* {!isAccommodationRequired &&
                isAccommodationRequired !== undefined && (
                  <span className="new-checkbox-fee">
                    <Form.Item name="dinner" valuePropName="checked">
                      <Checkbox
                        onChange={(e: any) => {
                          handleDinnerCalculation(e);
                        }}
                        className="checkbox"
                      >
                        <p className="checkbox-text">Svecana vecera</p>
                      </Checkbox>
                    </Form.Item>

                    <Form.Item name="registrationFee" valuePropName="checked">
                      <Checkbox
                        onChange={(e: any) => {
                          handleRegistrationFeeCalculation(e);
                        }}
                        className="checkbox"
                      >
                        <p className="checkbox-text">Kotizacija</p>
                      </Checkbox>
                    </Form.Item>
                  </span>
                )} */}

              {/* <Form.Item className="form-box" name={"city"} label="Grad:">
                <Input
                  onChange={(e) => handleFieldsChanges(e, "city")}
                  className="input-label"
                  placeholder="Unesite grad"
                />
              </Form.Item>
              <Form.Item className="form-box" name={"street"} label="Ulica:">
                <Input
                  onChange={(e) => handleFieldsChanges(e, "street")}
                  className="input-label"
                  placeholder="Unesite ulicu"
                />
              </Form.Item>
              <Form.Item
                className="form-box"
                name={"streetNumber"}
                label="Broj:"
              >
                <Input
                  onChange={(e) => handleFieldsChanges(e, "streetNumber")}
                  className="input-label"
                  placeholder="Unesite broj"
                />
              </Form.Item> */}
              {/* {fieldsFormData.country === "Srbija" ? (
                <>
                  <Form.Item
                    className="form-box"
                    name={"nationalId"}
                    label="Broj lične karte"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Potrebno je uneti broj lične karte!",
                    //   },
                    // ]}
                  >
                    <Input
                      onChange={(e) => handleFieldsChanges(e, "nationalId")}
                      type="number"
                      placeholder="Unesite broj lične karte"
                      className="input-label"
                      addonAfter={<EditOutlined />}
                    />
                  </Form.Item>
                  <Form.Item
                    className="form-box"
                    name={"personalId"}
                    label="JMBG:"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Potrebno je uneti JMBG!",
                      // },
                      {
                        validateTrigger: "submit",
                        validator: async (_, value) => {
                          if (value === undefined || value === null) return;
                          if (!validatePersonalId(value)) {
                            return Promise.reject(
                              new Error("Unesite ispravan JMBG")
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder="Unesite JMBG"
                      onChange={(e) => handleFieldsChanges(e, "personalId")}
                      type="number"
                      className="input-label"
                      addonAfter={<EditOutlined />}
                    />
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  className="form-box"
                  name={"nationalId"}
                  label="Broj pasoša:"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Potrebno je uneti broj pasoša!",
                  //   },
                  // ]}
                >
                  <Input
                    onChange={(e) => handleFieldsChanges(e, "nationalId")}
                    type="number"
                    className="input-label"
                    placeholder="Unesite broj pasoša "
                  />
                </Form.Item>
              )} */}
              <div
                className={!id ? "checkbox-group" : "checkbox-group disabled"}
              >
                <Form.Item
                  name="isAccommodationRequired"
                  valuePropName="checked"
                >
                  <Checkbox
                    onChange={(e: any) =>
                      handleCheckboxGroup(e, "isAccommodationRequired")
                    }
                    className="checkbox"
                  >
                    <p className="checkbox-text">Potreban smeštaj</p>
                  </Checkbox>
                </Form.Item>
                <Form.Item name="noAccommodation" valuePropName="checked">
                  <Checkbox
                    onChange={(e: any) =>
                      handleCheckboxGroup(e, "noAccommodation")
                    }
                    className="checkbox"
                  >
                    <p className="checkbox-text">Bez smeštaja</p>
                  </Checkbox>
                </Form.Item>
              </div>
            </div>
            <div className={isAccommodationRequired ? "header-box" : "close"}>
              <div
                style={{ width: isAccommodationRequired ? "331px" : "228px" }}
                className="wrapper-second"
              >
                <img className="image" alt="" src={Profile} />
                <p className="accordion-header" style={{ marginLeft: "10px" }}>
                  {isAccommodationRequired
                    ? "Podaci o smeštaju i učesnicima"
                    : "Podaci o učesnicima"}
                </p>
              </div>
            </div>
            <div className="inner-box-second">
              {!isAccommodationRequired ? null : (
                <Form.List name="accommodations">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          className="list-of-data"
                          align="baseline"
                        >
                          <AddNewAccommodation
                            form={form}
                            needAccommodation={isAccommodationRequired}
                            name={name}
                            restField={{ ...restField }}
                            remove={remove}
                            idEvent={idEvent}
                            oneEvent={oneEvent}
                            paramsId={id}
                            isAccommodationRequired={isAccommodationRequired}
                            handleGetData={handleGetData}
                            individual={true}
                            handleTotalPrice={handleTotalPrice}
                            handleSpinner={handleSpinner}
                            getNewPriceData={getNewPriceData}
                            handleGetPriceData={handleGetPriceData}
                            registrationFee={registrationFee}
                            compoanyRegistration={false}
                            allImportedParticipants={undefined}
                            importedParticipantOptions={undefined}
                            handleImportedParticipants={undefined}
                          />
                        </Space>
                      ))}
                      {fields.length === 0 ? (
                        <Form.Item className="button-property">
                          <Button icon={<PlusOutlined />} onClick={() => add()}>
                            Dodaj sobu
                          </Button>
                        </Form.Item>
                      ) : null}
                    </>
                  )}
                </Form.List>
              )}
            </div>
            <div className={"additional-fields"}>
              <div className="price-box">
                <p className="price-text">Ukupna cena učešća:</p>
                <span className="price-input">
                  {addThousandSeparator(totalPrice)}
                </span>
              </div>
              {!invoice && (
                <div>
                  {!id ? (
                    <CustomButton
                      danger={true}
                      htmlType={"submit"}
                      type={"primary"}
                      function={handleConfirmSaveForm}
                      text={"Potvrdi"}
                    />
                  ) : (
                    <CustomButton
                      danger={true}
                      htmlType={"submit"}
                      type={"primary"}
                      function={handleConfirmSaveForm}
                      text={"Izmeni"}
                    />
                  )}
                </div>
              )}
            </div>
          </Form>
        </Spin>
        <Modal
          maskClosable={false}
          open={showInfoModal}
          title={`Obavestenje`}
          onCancel={() => handleInfoModal()}
          onOk={() => handleInfoModal()}
          footer={[
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              key={1}
              function={() => handleInfoModal()}
              text={"Zatvori"}
            />,
          ]}
        >
          <p className="notification-content">{`Profaktura je poslata mejlom. Nije moguće promeniti podatke kod profakture koja je poslata na mejl!`}</p>
        </Modal>
      </div>
    </PageLayout>
  );
};

export default NewRegistrationPage;
